import React from 'react';
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { colours, urls } from '../helpers';

import PropTypes from 'prop-types';

import LoginButtonContainer from './../Containers/LoginButtonContainer';
import ThemeToggleContainer from './../Containers/ThemeToggleContainer';
import WebsocketConnectionContainer from './../Containers/WebsocketConnectionContainer';
import ProfileButtonContainer from '../Containers/ProfileButtonContainer';
import RecentToastsContainer from '../Containers/RecentToastsContainer';
import DataSpinnerComponent from '../Components/DataSpinnerComponent';

const links = [
  {
    name: 'Build', options: [
      { route: '/build', name: 'Build' },
      { route: '/build-health', name: 'Build Health' }
    ]
  },
  {
    name: 'Metrics', options: [
      { route: '/case-metrics', name: 'Case Metrics' },
      { route: '/engine-metrics', name: 'Engine Metrics' },
      { route: '/performance', name: 'Performance Metrics' },
      { route: '/artifacts-metrics', name: 'Artifacts Metrics' },
      { route: '/artifact-stats', name: 'Artifact Statistics' },
      { route: '/jira-metrics', name: 'Jira Metrics' },
      { route: '/artifact-health', name: 'Artifact Health' },
      { route: '/release-metrics', name: 'Release Metrics' },
      { route: '/aws-instances-cost', name: 'AWS Instances Cost' }
    ]
  },
  {
    name: 'Regressions', options: [
      { route: '/white', name: 'White Tests' },
      { route: '/test-studio', name: 'Test Studio Tests' },
      { route: '/case-merging', name: 'Case Merging Tests' },
      { route: '/case-amending', name: 'Case Amending Tests' },
      { route: '/artifact-regression', name: 'Artifact Regression' },
      { route: '/diff', name: 'Diff Tool Regression' },
      { route: '/export-regression', name: 'Export Regression' },
      { route: '/remote-acquire-regression', name: 'Remote Acquire Regression' },
      { route: '/installer', name: 'Installer Tests' },
      { route: '/axiom-ui', name: 'Axiom UI Tests' }
    ]
  },
  { route: '/cloud', name: 'Cloud' },
  { route: '/acquisition', name: 'Acquisition' },
  {
    name: 'Telemetry', options: [
      { route: '/telemetry-process', name: 'Process' },
      { route: '/telemetry-examine', name: 'Examine' },
      { route: '/telemetry-axiom-scans-today', name: 'Axiom Scans Today' }
    ]
  },
  { route: '/prtg', name: 'PRTG Status' },
];

const mapLinksWrapper = (nav) => {
  if (typeof nav === 'string') {
    if (nav === 'null') {
      return (mapLinks(links));
    } else {
      return (mapLinks(JSON.parse(nav)));
    }
  } else {
    if (nav === null) {
      return (mapLinks(links));
    }
    return (mapLinks(nav));
  }
};

const mapLinks = (links) => links.map(link => {
  if (link.route) {
    return (
      <LinkContainer key={link.name} to={link.route}>
        <NavItem>{link.name}</NavItem>
      </LinkContainer>
    );
  } else {
    return (
      <NavDropdown id={link.name} key={link.name} title={link.name}>
        {mapLinks(link.options)}
      </NavDropdown>
    );
  }
});

const NavBarComponent = (userConfiguration) => {
  const navItems = mapLinksWrapper(userConfiguration.customNav);
  return (
    <Navbar id="navbar" fixedTop>
      <Nav style={{ marginLeft: '-50px', marginTop: '-2px' }}>
        <NavItem>
          <div style={{ width: 35 }}>
            <DataSpinnerComponent
              spinnerType={'Grid'}
              color={colours.colours.blueDark}
              height={25}
              width={35}
              timeout={0}
            />
          </div>
        </NavItem>
      </Nav>
      <Navbar.Header>
        <Navbar.Brand>
          <Link to="/" style={{ padding: '13px 15px' }}>
            <img
              src={urls.MAGNET_LOGO_SRC}
              alt="logo"
              style={{
                height: '100%',
                display: 'inline-block',
                paddingRight: '10px'
              }}
            />
          </Link>
        </Navbar.Brand>
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav>
          {navItems}
        </Nav>
        <Nav pullRight >
          <NavItem>
            <LoginButtonContainer />
          </NavItem>
          <NavItem>
            <WebsocketConnectionContainer />
          </NavItem>
          <NavItem href="/swagger">Api</NavItem>
          <ThemeToggleContainer />
          <NavItem>
            <ProfileButtonContainer />
          </NavItem>
          <RecentToastsContainer />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavBarComponent.propTypes = { userConfiguration: PropTypes.object.isRequired };

export default NavBarComponent;


// WEBPACK FOOTER //
// src/Components/NavBarComponent.jsx